import { useEffect } from "react";

const useClickOutside = (onOutside: () => void, el?: HTMLElement) => {
  useEffect(() => {
    if (el) {
      const onClick = (ev: MouseEvent) => {
        const rect = el.getBoundingClientRect();
        if (ev.clientX < rect.left || ev.clientX > rect.right || ev.clientY < rect.top || ev.clientY > rect.bottom) {
          onOutside();
        }
      }
      window.addEventListener("mousedown", onClick);
      return () => window.removeEventListener("mousedown", onClick);
    }
  }, [onOutside, el]);
};

export default useClickOutside;